<template lang="pug">
div(v-if="hasFitDrills")
    //-  We don't trigger initControls so we'll never have drills server side
    Fits(
        v-if="hasNoFitment"
        type="select"
        key="select-fitment"
    )
    Fits(
        v-if="showFitsGood && isGoodVehicleSoFar && !showVehicleSelector && !showMismatch"
        type="good"
        key="good-fitment"
    )
    Fits(
        v-if="!isGoodVehicleSoFar && !showVehicleSelector"
        type="bad"
        key="bad-fitment"
    )
    Fits(
        v-if="!hasFullFitment && isGoodVehicleSoFar && !hasNoFitment"
        type="more"
        key="more-fitment"
    )
    Fits(
        v-if="showMismatch && !showVehicleSelector && !hasNoFitment"
        type="mismatch"
        key="mismatch-fitment"
    )

    div(
        v-show="showVehicleSelector || (!showFitsGood && isGoodVehicleSoFar)"
        class="mb-0 md:mb-5"
    )
        div(data-testid="drillSelection")
            Drill(
                v-for="drill in pControls.drills"
                v-if="drill.isFitment"
                :id="`scrollTarget-${drill.type}`"
                :key="drill.type"
                :drill="drill"
                :currentValue="drill.currentValue"
                @changed="drillChanged"
                @changedNative="drillChangedNative"
                @click.native="alert(drill.isDisabled)"
            )
            a(@click="$store.dispatch('fitment/showFitmentModal', { isFitsMode: true })") Don't see your vehicle listed?
</template>

<script>
import { linkBuilders } from '@/helpers/mixins'
import Card from '@/components/style/card'
import Drill from '../drill'
import Fits from './fits'

export default {
    components: {
        Drill,
        Fits,
        Card,
    },
    mixins: [linkBuilders],
    inject: ['alert', '$pageBus'],
    data() {
        return {
            showVehicleSelector: false,
            setFitmentTimeout: null,
        }
    },
    computed: {
        showMismatch() {
            return !!this.$store.state.product.mismatchedProduct && !this.pControls.hasInteraction
        },
        isGoodVehicleSoFar() {
            return this.pControls.isGoodVehicleSoFar
        },
        fitment() {
            return this.$store.state.fitment.data
        },
        pControls() {
            return this.$store.state.product.controls
        },
        hasFitDrills() {
            return this.pControls.drillConfig.fitment.length > 0
        },
        hasNoFitment() {
            return !this.fitment.year || this.fitment.year === ''
        },
        showFitsGood() {
            return !this.showVehicleSelector && this.hasFullFitment
        },
        hasFullFitment() {
            const fitmentDrillTypes = this.pControls.drillConfig.fitment
            return (
                fitmentDrillTypes.filter((drillType) => {
                    return !this.fitment[drillType] || this.fitment[drillType] === ''
                }).length === 0
            )
        },
    },
    watch: {
        // you jumped to a new product line
        '$store.state.product.controls.drillConfig'() {
            this.showVehicleSelector = false
        },
    },
    mounted() {
        this.$pageBus.$on('changeVehicle', () => {
            this.showVehicleSelector = true
        })
    },
    beforeDestroy() {
        this.$pageBus.$off('changeVehicle')
    },
    methods: {
        // triggered by manual and auto selects
        drillChanged(obj) {
            this.$store.dispatch('product/fillNextDrill', obj)

            // http://0.0.0.0:8080/p/bodyguard-traditional-extreme-front-bumper/v/dodge/ram-3500/ <-- no year, but Make/Model would auto-select, save full fitment!
            if (this.hasNoFitment) this.trySetFitment(obj)
        },
        // triggered by manual select
        drillChangedNative(obj) {
            this.$store.dispatch('product/resetControls', obj) // reset controls 2 below this one
            this.trySetFitment(obj)
        },
        trySetFitment(obj) {
            // not last fitment drill, or it is, and it's auto-select is bad
            if (
                obj.sourceDrillType !== this.pControls.drillConfig.lastFitment ||
                obj.hasBadAutoSelect ||
                this.setFitmentTimeout
            )
                return

            // When you have no fitment and manually select the last drill, both changed and changedNative fire.  Due to all the other combos each cover, I don't think we can change it, so debounce.
            this.setFitmentTimeout = setTimeout(() => {
                this.$store.dispatch('product/setFitmentFromDrills').then(() => {
                    this.showVehicleSelector = false

                    // the product page shouldn't update the url when the fitment changes
                    if (this.$route.meta.isProductPage) return

                    // update url to have MMY
                    // Need to preserve the Query string if they have one so that our State doesn't refresh.
                    const destUrl = this.linkBuilder({
                        name: 'product',
                        params: { noUpdateScroll: true },
                        query: Object.assign({}, this.$route.query),
                    })

                    this.$push.to(destUrl)
                })
                this.setFitmentTimeout = null
            }, 1)
        },
    },
}
</script>
